export default __webpack_public_path__ + "static/marco-e18ebf49848ee1f7039b7217cc5dfd2a.jpg";